import api, { ApiResponse } from './api';

// ========== Tipler ==========

export interface NFCPunchResponse {
  employeeId: number;
  fullName: string;
  department: string;
  position: string;
  actionType: 'GIRIS' | 'CIKIS' | 'CIKIS_GUNCELLEME';
  time: string;
  registered: boolean;
}

export interface NFCPunchError {
  cardUid: string;
  registered: boolean;
}

export interface NFCTodaySummary {
  totalIn: number;
  totalOut: number;
  uniqueEmployees: number;
  date: string;
}

export interface NFCTodayLog {
  logId: number;
  employeeId: number;
  fullName: string;
  department: string;
  employeeCode: string;
  checkIn: string | null;
  checkOut: string | null;
  workDuration: number | null;
}

export interface NFCSearchEmployee {
  employeeId: number;
  fullName: string;
  employeeCode: string;
  department: string;
  hasCard: boolean;
}

export interface RegisterCardResponse {
  employeeId: number;
  cardUid: string;
  fullName: string;
}

// ========== Servis ==========

const nfcService = {
  /** NFC kart okutma - otomatik giris/cikis */
  punch: (cardUid: string): Promise<ApiResponse<NFCPunchResponse | NFCPunchError>> =>
    api.post('/nfc/punch', { cardUid }),

  /** Bugunun ozeti */
  getTodaySummary: (): Promise<ApiResponse<NFCTodaySummary>> =>
    api.get('/nfc/today-summary'),

  /** Bugunun tum kayitlari */
  getTodayLogs: (): Promise<ApiResponse<NFCTodayLog[]>> =>
    api.get('/nfc/today-logs'),

  /** Kart UID'sini personele esle */
  registerCard: (employeeId: number, cardUid: string): Promise<ApiResponse<RegisterCardResponse>> =>
    api.post('/nfc/register-card', { employeeId, cardUid }),

  /** Personel arama (kart kayit icin) */
  searchEmployee: (query: string): Promise<ApiResponse<NFCSearchEmployee[]>> =>
    api.get(`/nfc/search-employee?q=${encodeURIComponent(query)}`),
};

export default nfcService;
